import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Text } from '@nerdwallet/currency';

const Label = ({ marketplaceEntity, text, textPath }) => {
  const textToShow = text || _.get(marketplaceEntity, textPath);
  if (!textToShow) {
    return null;
  }

  return (
    <Text size="small" component="p" align="center" light>
      {textToShow}
    </Text>
  );
};

Label.propTypes = {
  marketplaceEntity: PropTypes.object,
  text: PropTypes.string,
  textPath: PropTypes.string,
};

Label.defaultProps = {
  marketplaceEntity: {},
};

export default Label;
